import { render, staticRenderFns } from "./RedirectList.vue?vue&type=template&id=5969ff86&scoped=true&"
import script from "./RedirectList.vue?vue&type=script&lang=js&"
export * from "./RedirectList.vue?vue&type=script&lang=js&"
import style0 from "./RedirectList.vue?vue&type=style&index=0&id=5969ff86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5969ff86",
  null
  
)

export default component.exports